/* ============================================================
   Rodeo West — scripts propios (prefijo rw-)
   Vanilla JS. Un init por componente, todos desde DOMContentLoaded.
   ============================================================ */
(function () {
  'use strict';

  function initReveals() {
    var els = document.querySelectorAll('.rw-reveal, .rw-reveal-scale');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rw-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-rw-delay') || 0;
            setTimeout(function () { entry.target.classList.add('rw-visible'); }, Number(delay));
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-rw-contador]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-rw-contador')) || 0;
          var suffix = el.getAttribute('data-rw-sufijo') || '';
          var dur = 1200;
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased) + suffix;
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          io.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  // Barra de compra fija en celular: espeja el botón real y lo pulsa,
  // así respeta la talla elegida, el inventario y el carrito del tema.
  function initCompraFija() {
    var barra = document.querySelector('[data-rw-compra-fija]');
    var real = document.querySelector('[data-rw-add]');
    if (!barra || !real || !('IntersectionObserver' in window)) return;
    var btn = barra.querySelector('[data-rw-compra-fija-btn]');
    var precio = barra.querySelector('[data-rw-compra-fija-precio]');
    var precioReal = document.querySelector('[data-rw-precio]');
    function espejar() {
      btn.textContent = real.textContent.trim();
      btn.disabled = real.disabled;
      if (precio && precioReal) precio.textContent = precioReal.textContent.trim();
    }
    espejar();
    new MutationObserver(espejar).observe(real, { attributes: true, childList: true, characterData: true, subtree: true });
    if (precioReal) new MutationObserver(espejar).observe(precioReal, { childList: true, characterData: true, subtree: true });
    new IntersectionObserver(function (e) {
      var visible = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      barra.classList.toggle('is-visible', visible);
      barra.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }).observe(real);
    btn.addEventListener('click', function () { real.click(); });
  }

  function initTallaSelector() {
    var wraps = document.querySelectorAll('[data-rw-producto]');
    wraps.forEach(function (wrap) {
      var dataEl = wrap.querySelector('[data-rw-variantes]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = wrap.querySelector('input[name="id"]');
      var precioEl = wrap.querySelector('[data-rw-precio]');
      var precioCompareEl = wrap.querySelector('[data-rw-precio-compare]');
      var addBtn = wrap.querySelector('[data-rw-add]');
      var pills = wrap.querySelectorAll('[data-rw-talla]');
      var stockEl = wrap.querySelector('[data-rw-stock]');
      var stockUmbral = stockEl ? parseInt(stockEl.getAttribute('data-rw-stock-umbral') || '5', 10) : 5;

      function money(cents) {
        return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' MXN';
      }

      function selectVariant(variantId) {
        var v = variants.find(function (x) { return String(x.id) === String(variantId); });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (precioEl) precioEl.textContent = money(v.price);
        if (precioCompareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            precioCompareEl.textContent = money(v.compare_at_price);
            precioCompareEl.style.display = '';
          } else {
            precioCompareEl.style.display = 'none';
          }
        }
        pills.forEach(function (p) {
          var isActive = String(p.getAttribute('data-rw-talla')) === String(variantId);
          p.classList.toggle('rw-talla-activa', isActive);
          p.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        if (stockEl) {
          // Sin números: decir "quedan X piezas" filtra el inventario real a
          // quien esté viendo la página (incluida la competencia). Solo se
          // avisa el nivel de urgencia, nunca la cantidad exacta.
          if (v.available && v.nivel) {
            stockEl.textContent = v.nivel === 'ultima' ? '¡No te quedes sin la tuya, es la última!' : '¡Quedan pocas piezas en esta talla!';
            stockEl.style.display = '';
          } else {
            stockEl.style.display = 'none';
          }
        }
        if (addBtn) {
          if (v.available) {
            addBtn.removeAttribute('disabled');
            addBtn.textContent = addBtn.getAttribute('data-rw-texto-add') || 'Agregar al carrito';
          } else {
            addBtn.setAttribute('disabled', 'disabled');
            addBtn.textContent = addBtn.getAttribute('data-rw-texto-agotado') || 'Agotado';
          }
        }
      }

      pills.forEach(function (p) {
        p.addEventListener('click', function () {
          if (p.hasAttribute('disabled')) return;
          selectVariant(p.getAttribute('data-rw-talla'));
        });
      });
    });
  }

  function initGaleria() {
    var galerias = document.querySelectorAll('[data-rw-galeria]');
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-rw-imagen-principal]');
      var minis = galeria.querySelectorAll('[data-rw-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var full = mini.getAttribute('data-rw-full');
          if (!full) return;
          var alt = mini.getAttribute('data-rw-alt');
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = full;
            if (alt) principal.alt = alt; // la foto grande describe lo que muestra ahora
            principal.style.opacity = '1';
          }, 120);
          minis.forEach(function (m) { m.classList.remove('rw-mini-activa'); m.setAttribute('aria-pressed', 'false'); });
          mini.classList.add('rw-mini-activa');
          mini.setAttribute('aria-pressed', 'true');
        });
      });
    });
  }

  function initCartTallaSwap() {
    // Delegado en document (no en cada <select>): el <cart-items> de Dawn
    // vuelve a dibujar su HTML por dentro (AJAX) cada vez que cambia algo en
    // el carrito, así que cualquier listener puesto directo en el <select>
    // se pierde en cuanto Shopify lo reemplaza. Delegar en un nodo que nunca
    // se destruye hace que siga funcionando sin importar cuántas veces se
    // redibuje el carrito.
    //
    // IMPORTANTE: <cart-items> (assets/cart.js de Dawn) tiene su PROPIO
    // listener de "change" en el custom element, y como nuestro <select> vive
    // adentro de <cart-items>, el evento pasa por ahí antes de llegar a
    // document — Dawn lo agarra primero y lo trata como si fuera su selector
    // de cantidad (usa event.target.dataset.index, que en nuestro <select> no
    // existe), rompiendo el cambio de talla. Por eso escuchamos en fase de
    // CAPTURA (antes de que baje a los hijos) y detenemos la propagación para
    // que Dawn nunca llegue a verlo.
    document.addEventListener('change', function (e) {
      var select = e.target.closest && e.target.closest('[data-rw-cart-talla-select]');
      if (!select) return;
      e.stopPropagation(); // corre en captura (ver flag más abajo), antes de que <cart-items> lo vea
      var wrap = select.closest('[data-rw-cart-talla-wrap]');
      if (!wrap) return;
      var newVariantId = select.value;
      var lineKey = wrap.getAttribute('data-rw-line-key');
      var qty = parseInt(wrap.getAttribute('data-rw-qty'), 10) || 1;
      select.disabled = true;
      wrap.classList.add('rw-cart-talla-cargando');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: newVariantId, quantity: qty })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('rw-cart-talla-swap: add failed');
          window.location.reload();
        })
        .catch(function () {
          // Si algo falla a medio camino, recargamos para que el carrito
          // refleje el estado real del servidor en vez de quedar inconsistente.
          window.location.reload();
        });
    }, true); // true = fase de captura, corre antes que el listener de <cart-items>
  }

  function initMarquesinaVelocidad() {
    var tracks = document.querySelectorAll('[data-rw-marquesina-vel]');
    tracks.forEach(function (t) {
      var seg = t.getAttribute('data-rw-marquesina-vel');
      if (seg) t.style.animationDuration = seg + 's';
    });
  }

  /* Comparador de variantes: dos fotos superpuestas + divisor.
     El arrastre, el teclado y el soporte de lectores de pantalla los da un
     <input type="range"> nativo estirado sobre el escenario, así que aquí solo
     queda sincronizar la posición y cambiar de variante. El recorte y la
     alineación son 100% CSS (ver .rw-cmp-capa-interna en rw-styles.css). */
  function initComparador() {
    var comparadores = document.querySelectorAll('[data-rw-comparador]');
    if (!comparadores.length) return;

    comparadores.forEach(function (cmp) {
      var range = cmp.querySelector('[data-rw-cmp-range]');
      var escenario = cmp.querySelector('[data-rw-cmp-escenario]');
      /* Cada lado tiene su foto y su etiqueta. "der" es la capa recortada por
         la máscara (que revela desde la derecha); "izq" es la base que va
         debajo y queda a la vista del lado izquierdo. */
      var lados = {
        der: {
          foto: cmp.querySelector('[data-rw-cmp-foto-variante]'),
          etiqueta: cmp.querySelector('[data-rw-cmp-etiqueta-variante]'),
        },
        izq: {
          foto: cmp.querySelector('[data-rw-cmp-foto-base]'),
          etiqueta: cmp.querySelector('[data-rw-cmp-etiqueta-base]'),
        },
      };
      var botones = cmp.querySelectorAll('[data-rw-cmp-variante]');
      var titulo = cmp.getAttribute('data-rw-cmp-titulo') || '';
      var foto = lados.der.foto; /* referencia para el `sizes` de la precarga */
      if (!range) return;

      /* --- medidas en caché ---
         Los anchos se leen aquí y NO dentro de pintar(): consultar offsetWidth
         después de escribir una custom property fuerza un reflow síncrono, y
         al arrastrar eso pasaría en cada frame. Se remiden solo cuando algo
         los puede haber cambiado: tamaño del escenario, texto de la etiqueta
         o carga de las fuentes (antes de que la fuente llegue, el ancho de
         texto miente). */
      var anchoEscenario = 0;
      var anchoEtiqueta = { izq: 0, der: 0 };
      /* 14 px de separación del borde exterior + 10 px de aire contra el
         divisor: por debajo de eso la etiqueta ya invade la otra mitad. */
      var HOLGURA = 24;
      function medir() {
        anchoEscenario = escenario ? escenario.clientWidth : 0;
        anchoEtiqueta.izq = lados.izq.etiqueta ? lados.izq.etiqueta.offsetWidth : 0;
        anchoEtiqueta.der = lados.der.etiqueta ? lados.der.etiqueta.offsetWidth : 0;
      }

      function nombreDe(k) {
        var et = lados[k].etiqueta;
        var t = et ? et.textContent.trim() : '';
        return t || (k === 'izq' ? 'la base' : 'la variante');
      }

      /* --- posición del divisor --- */
      var pendiente = null;
      function pintar() {
        pendiente = null;
        var p = parseFloat(range.value);
        if (isNaN(p)) p = 50;
        cmp.style.setProperty('--rw-cmp-p', p + '%');

        /* Cada nombre se esconde cuando su mitad ya no lo puede contener, en
           vez de quedarse encima de la foto contraria. */
        var visibleIzq = anchoEscenario * p / 100;
        var visibleDer = anchoEscenario - visibleIzq;
        if (lados.izq.etiqueta) {
          lados.izq.etiqueta.classList.toggle('rw-cmp-etiqueta--fuera', visibleIzq < anchoEtiqueta.izq + HOLGURA);
        }
        if (lados.der.etiqueta) {
          lados.der.etiqueta.classList.toggle('rw-cmp-etiqueta--fuera', visibleDer < anchoEtiqueta.der + HOLGURA);
        }

        /* Se dice QUÉ hay de cada lado, no solo el porcentaje: con las
           etiquetas escondidas, esta es la única pista para quien navega con
           lector de pantalla. */
        range.setAttribute('aria-valuetext',
          Math.round(p) + '% ' + nombreDe('izq') + ' a la izquierda, ' +
          Math.round(100 - p) + '% ' + nombreDe('der') + ' a la derecha');
      }
      /* El range puede disparar decenas de eventos por segundo al arrastrar;
         con rAF se colapsan en una sola escritura por frame. */
      function programarPintado() {
        if (pendiente !== null) return;
        pendiente = requestAnimationFrame(pintar);
      }
      range.addEventListener('input', programarPintado);
      medir();
      pintar();

      /* El ancho del escenario cambia al girar el teléfono o al redimensionar;
         sin remedir, el umbral de las etiquetas se quedaría con el ancho viejo. */
      if ('ResizeObserver' in window && escenario) {
        new ResizeObserver(function () { medir(); pintar(); }).observe(escenario);
      } else {
        window.addEventListener('resize', function () { medir(); pintar(); });
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { medir(); pintar(); });
      }

      /* --- precarga de las variantes ---
         Van en caché para que al cambiar de color no haya parpadeo. Se copia
         el `sizes` de la foto real para que el navegador elija del srcset el
         MISMO candidato que terminará mostrando; si no, se precargaría un
         archivo distinto al que luego se pide (descarga doble).

         Se dispara cuando el comparador se acerca al viewport, no al cargar
         la página: son varias fotos grandes y no deben competir con el primer
         pintado. Para cuando el usuario llega a la sección, ya están listas. */
      var sizesAttr = foto ? (foto.getAttribute('sizes') || '') : '';
      var yaPrecargado = false;
      function precargar() {
        if (yaPrecargado) return;
        yaPrecargado = true;
        botones.forEach(function (b) {
          var url = b.getAttribute('data-rw-cmp-img');
          if (!url) return;
          var pre = new Image();
          var ss = b.getAttribute('data-rw-cmp-srcset');
          if (ss) { pre.sizes = sizesAttr; pre.srcset = ss; }
          pre.src = url;
        });
      }
      if ('IntersectionObserver' in window) {
        var ioPre = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            if (!e.isIntersecting) return;
            precargar();
            ioPre.disconnect();
          });
        }, { rootMargin: '400px 0px' });
        ioPre.observe(cmp);
      } else {
        precargar();
      }

      /* --- cambio de variante ---
         No se toca la posición del slider ni el tamaño del contenedor: solo
         se reemplaza el src de la capa B. Se espera a decode() para que el
         cambio sea en un solo frame ya pintado, sin flash intermedio. */
      function elegir(boton) {
        var lado = boton.getAttribute('data-rw-cmp-lado') || 'der';
        var destino = lados[lado];
        if (!destino || !destino.foto) return;
        var url = boton.getAttribute('data-rw-cmp-img');
        var srcset = boton.getAttribute('data-rw-cmp-srcset') || '';
        var nombre = boton.getAttribute('data-rw-cmp-etiqueta') || '';
        if (!url) return;

        /* Solo se apaga el resto de SU fila: las dos filas (izquierda y
           derecha) llevan selección independiente. */
        botones.forEach(function (b) {
          if ((b.getAttribute('data-rw-cmp-lado') || 'der') !== lado) return;
          var activo = b === boton;
          b.classList.toggle('rw-cmp-variante--activa', activo);
          b.setAttribute('aria-pressed', activo ? 'true' : 'false');
        });

        var aplicado = false;
        function aplicar() {
          if (aplicado) return;
          aplicado = true;
          destino.foto.srcset = srcset;
          destino.foto.src = url;
          /* El alt conserva el contexto del producto, no solo el color:
             "Café — La misma horma, dos acabados" en vez de solo "Café". */
          destino.foto.alt = titulo ? nombre + ' — ' + titulo : nombre;
          if (destino.etiqueta) {
            destino.etiqueta.textContent = nombre;
            /* El nombre nuevo puede ser más largo o más corto que el anterior
               ("Vino" → "Chocolate"): sin remedir, el umbral para esconderlo
               seguiría siendo el del nombre viejo. */
            medir();
            pintar();
          }
        }

        /* Se espera a que la nueva foto esté decodificada para que el cambio
           ocurra en un solo frame, sin estado intermedio en blanco.
           `sizes` es obligatorio aquí: sin él, una imagen desprendida con
           srcset no puede elegir candidato, decode() se queda pendiente para
           siempre y la foto nunca se cambiaría. El setTimeout es la red de
           seguridad por si aun así no resuelve (caché, formatos raros). */
        var siguiente = new Image();
        if (srcset) { siguiente.sizes = sizesAttr; siguiente.srcset = srcset; }
        siguiente.src = url;
        if (siguiente.decode) {
          siguiente.decode().then(aplicar).catch(aplicar);
          setTimeout(aplicar, 300);
        } else {
          aplicar();
        }
      }

      botones.forEach(function (b) {
        b.addEventListener('click', function () { elegir(b); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContadores();
    initTallaSelector();
    initCompraFija();
    initGaleria();
    initCartTallaSwap();
    initMarquesinaVelocidad();
    initComparador();
  });
})();
